var _reduceInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/reduce");

var _concatInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/concat");

var _mapInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/map");

var path = require('path');

var parse = path.parse || require('path-parse'); // eslint-disable-line global-require


var getNodeModulesDirs = function getNodeModulesDirs(absoluteStart, modules) {
  var prefix = '/';

  if (/^([A-Za-z]:)/.test(absoluteStart)) {
    prefix = '';
  } else if (/^\\\\/.test(absoluteStart)) {
    prefix = '\\\\';
  }

  var paths = [absoluteStart];
  var parsed = parse(absoluteStart);

  while (parsed.dir !== paths[paths.length - 1]) {
    paths.push(parsed.dir);
    parsed = parse(parsed.dir);
  }

  return _reduceInstanceProperty(paths).call(paths, function (dirs, aPath) {
    return _concatInstanceProperty(dirs).call(dirs, _mapInstanceProperty(modules).call(modules, function (moduleDir) {
      return path.resolve(prefix, aPath, moduleDir);
    }));
  }, []);
};

module.exports = function nodeModulesPaths(start, opts, request) {
  var _context;

  var modules = opts && opts.moduleDirectory ? _concatInstanceProperty(_context = []).call(_context, opts.moduleDirectory) : ['node_modules'];

  if (opts && typeof opts.paths === 'function') {
    return opts.paths(request, start, function () {
      return getNodeModulesDirs(start, modules);
    }, opts);
  }

  var dirs = getNodeModulesDirs(start, modules);
  return opts && opts.paths ? _concatInstanceProperty(dirs).call(dirs, opts.paths) : dirs;
};